export enum CommonOutdoorSpaces {
    Courtyard = 3800,
    RoofDeck = 3801
}